import React from "react";
import { 
  Navigation, 
  Page, 
  Storage, 
  TaskImageClick,
  TaskMultiSelect,
  Image
} from "@bittnerdevelopmentgroup/interactive";

import panel1 from "./assets/PrinEco4_ElasticityOfDemand_p1.jpg"
import panel2 from "./assets/PrinEco4_ElasticityOfDemand_p2.jpg"

class ElasticityOfDemand extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div className="elasticityOfDemand">
        <div className="sr-only" aria-hidden="true">
          {[panel1, panel2].map(src=><img alt="" src={src}/>)}
        </div>
        <Navigation interactiveId="chapter-4b">
          <Page>
            <p>
              Javier is shopping for groceries, and salt is on his list. He sees that it costs $2. Last time he bought salt (a really long time ago), it was only $1.
            </p>
            <p>
              Javier, a former economics major, quickly realizes that that's a 100% increase in the price of salt! <b>What do you think Javier is most likely to think next?</b>
            </p>
            <p>
              <i>Choose the thought bubble representing Javier's reaction.</i>
            </p>
            <TaskImageClick
              state={Storage()}
              hotspots={[
                {
                  correct: false,
                  label: "Jeez! The price doubled. No, thank you. I will not be buying this!",
                  feedback: "Not quite! $2 is still a small purchase, and Javier doesn't have to buy salt very frequently, so it's a small part of his total budget. Also, there isn't much else that can be used instead of salt, so he'll probably buy it anyway.",
                  style: {
                    top: "45px",
                    left: "465px",
                    width: "165px",
                    height: "65px",
                  },
                },
                {
                  correct: true,
                  label: "I hardly ever buy salt, and even with the doubled price it's still so cheap. Plus, it's not like I can use anything else in place of salt. I'm going to buy it!",
                  feedback: "This purchase won't take up much of Javier's budget, and there's nothing he can easily replace salt with in his cooking. Therefore, he'll probably still buy the $2 salt.",
                  style: {
                    top: "185px",
                    left: "485px",
                    width: "210px",
                    height: "110px",
                  },
                },
              ]}
            >
              <Image
                src={panel1}
                alt="A photo of an older middle aged man shopping in the spices and seasoning aisle of a supermarket."
                photoCredit={"Anna Berkut/Stocksy"}
              />
            </TaskImageClick>
          </Page>
          <Page>
            <p>
              Izzy wants something sweet for an afternoon study break. At the food trucks on campus, she sees that pastries cost $6 each. Last time she bought pastries (just last week; she buys them every Tuesday), they were only $3 each.  
            </p>
            <p>
              Since Izzy is taking economics right now, she realizes that that's a 100% increase in the price of pastries!
            </p>
            <p>
              <em>Using what you've learned about elasticity, select the thought bubble representing Izzy's most likely reaction.</em>
            </p>
            <TaskImageClick
              state={Storage()}
              hotspots={[
                {
                  correct: true,
                  label: "Jeez! The price doubled. No, thank you! I will buy something cheaper at the next truck instead!",
                  feedback: "This is a good Izzy buys weekly, so it will quickly add up to be a significant amount in her budget. Plus, it is a good with a lot of substitutes. Likely, Izzy will go somewhere else in light of her price sensitivity.",
                  style: {
                    top: "130px",
                    left: "12px",
                    width: "170px",
                    height: "75px",
                  },
                },
                {
                  correct: false,
                  label: "Oh well, I buy pastries here every week. Even though the price is higher, I'm going to buy it!",
                  feedback: "Consider the fact that Izzy buys this item weekly—it will quickly add up to be a large portion of her budget over time! Also, there are other food trucks around, so she has plenty of other options for a snack.",
                  style: {
                    top: "60px",
                    left: "212px",
                    width: "180px",
                    height: "75px",
                  },
                },
              ]}
            >
              <Image
                src={panel2}
                alt="A photo of a shopper considering the offerings of a pastry vendor, in outdoor setting."
                photoCredit={"PER Images/Stocksy"}
              />
            </TaskImageClick>
          </Page>
          <Page>
            <p>
              The price of both goods doubled: Javier's salt increased from $1 to $2, and Izzy's pastry increased from $3 to $6. Yet Javier decided to make the purchase anyway, while Izzy didn't.
            </p>
            <TaskMultiSelect
              key="eodpanel4"
              state={Storage()}
              prompt={<><b>Which of the following do you think make a consumer more likely to buy something, even if the price increases?</b>&nbsp;<i>Select all that apply.</i></>}
              data={[
                {
                  label: (
                    <React.Fragment>
                      <>
                        There's nothing else they can replace the good with.
                      </>
                    </React.Fragment>
                  ),
                  correct: true,
                },
                {
                  label: (
                    <React.Fragment>
                      <>
                        The purchase doesn't take up too much of their budget.
                      </>
                    </React.Fragment>
                  ),
                  correct: true,
                },
                {
                  label: (
                    <React.Fragment>
                      <>
                        They need the good very badly.
                      </>
                    </React.Fragment>
                  ),
                  correct: true,
                },
                {
                  label: (
                    <React.Fragment>
                      <>
                        A lot of time has passed since the price changed. 
                      </>
                    </React.Fragment>
                  ),
                  correct: false,
                },
              ]}
              correctFeedback={
                <>
                  <p>
                    All of these factors make a consumer more likely to buy a good, even if the price has increased. In other words, these factors make the good <b>inelastic</b>. Economists would call these three factors
                    <ul>
                      <li>the existence of substitutes;</li>
                      <li>the share of the budget spent on the good; and</li>
                      <li>necessities versus luxury goods.</li>
                    </ul>
                  </p>
                  <p>
                    The last option, in which a lot of time has passed since the price changed, actually makes the good <i>more</i> elastic. After all, the consumer has had more time to seek out other options, or substitutes.
                  </p>
                </>
              }
              incorrectFeedback="Which factors would make you care less about the price as a customer? Be sure to double check that you selected all of the correct answers."
            />
          </Page>
        </Navigation>
      </div>
    )
  }
}

export default ElasticityOfDemand
